import { getActionableByCode } from './../../../../utilities/error-codes';
import { sendAncillaryEventToCustomerIO } from './../../../../utilities/customer-io-ancillary-events';

export default (errorInfo, subFunnelName) => {
  const url = getSecondSlashPath(window?.location?.pathname);
  const sfunnelName = !subFunnelName ? 'Ancillary' : subFunnelName;

  function getSecondSlashPath(pathname) {
    const pathSegments = pathname.split('/');
    pathSegments.shift();
    pathSegments.shift();
    const remainingPath = pathSegments.join('/');

    return `/${remainingPath}`;
  }

  const info = errorInfo?.data ? errorInfo.data : errorInfo;
  const type = info?.actionable === 'ABORT' || info?.actionable === 'USER_ABORT' ? 'fatal' : 'warning';
  const code = info?.code || 'NA';
  const actionable = info?.actionable || 'NA';
  const recategorizedActionable = getActionableByCode(code, actionable);

  const result = {
    'event': 'am_error',
    'funnel_name': 'MYB',
    'sub_funnel_name': sfunnelName || 'NA',
    'error_message': info?.message || info?.msg || errorInfo?.message || 'NA',
    'error_type': type,
    'error_category': recategorizedActionable,
    'error_code': code,
    'error_desc': info?.extraInfo?.debugging_stuff_here || info?.errorExtraInfo || info?.extraInfo || errorInfo?.extraInfo || 'NA',
    'error_source': 'Web',
    'error_url': url,
    'statusCode': info?.statusCode || info?.status || errorInfo?.statusCode || errorInfo?.status || 'NA',
  };

  let pnrData = window.currentPNR;
  let pnrCode = null;
  
  if (pnrData && (pnrData.pnrCode || pnrData.pnr)) {
    pnrCode = pnrData.pnrCode || pnrData.pnr;
  }
  
  if (!pnrCode) {
    try {
      const storedPNR = JSON.parse(localStorage.getItem('currentPNR') || '{}');
      pnrCode = storedPNR?.pnrCode || storedPNR?.pnr;
      if (pnrCode) pnrData = storedPNR;
    } catch (e) {
      // Error
    }
  }
  
  if (!pnrCode) {
    const urlParams = new URLSearchParams(window.location.search);
    pnrCode = urlParams.get('pnr');
  }
  
  if (!pnrCode && window.__REDUX_STORE__) {
    try {
      const state = window.__REDUX_STORE__.getState();
      pnrCode = state?.pnr?.pnrCode || state?.booking?.pnrCode || state?.currentPNR?.pnrCode;
    } catch (e) {
      // Error
    }
  }

  let userEmail = 'error-tracking@aeromexico.com'; // Default fallback
  
  if (pnrData) {
    userEmail = pnrData.passengers?.[0]?.email || 
               pnrData.passengers?.[0]?.contactEmail ||
               pnrData.email ||
               pnrData.contactInformation?.email ||
               userEmail;
  }

  const pnrInfo = pnrCode ? {
    pnrCode,
    email: userEmail,
    firstName: pnrData?.passengers?.[0]?.firstName || 'Guest',
    lastName: pnrData?.passengers?.[0]?.lastName || 'User',
  } : {
    pnrCode: 'UNKNOWN',
    email: userEmail,
    firstName: 'Guest',
    lastName: 'User',
  };

  try {
    sendAncillaryEventToCustomerIO('Ancillary_error', {
      event: 'am_error',
      errorMessage: result.error_message,
      errorType: result.error_type,
      errorCode: result.error_code,
      errorCategory: result.error_category,
      subFunnel: result.sub_funnel_name,
      pnrCode: pnrInfo.pnrCode,
      email: pnrInfo.email,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    }, pnrInfo);
  } catch (customerIOError) {
    // Error
  }

  return result;
};